import api from './api';

// جلب جميع الطلبات
export const getOrders = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/orders?${queryParams}`);
  return response.data;
};

// جلب طلب معين
export const getOrderById = async (id) => {
  const response = await api.get(`/orders/${id}`);
  return response.data;
};

// تحديث حالة الطلب
export const updateOrderStatus = async (id, status, notes) => {
  const response = await api.put(`/orders/${id}/status`, { status, notes });
  return response.data;
};

// تخصيص منفذ للطلب
export const assignOrder = async (id, assignment) => {
  const response = await api.post(`/orders/${id}/assign`, assignment);
  return response.data;
};

// إزالة منفذ من الطلب
export const removeAssignment = async (orderId, assignmentId) => {
  const response = await api.delete(`/orders/${orderId}/assignments/${assignmentId}`);
  return response.data;
};

// تحديث منفذ
export const updateAssignment = async (orderId, assignmentId, data) => {
  const response = await api.put(`/orders/${orderId}/assignments/${assignmentId}`, data);
  return response.data;
};

// إضافة ملاحظة للطلب
export const addOrderNote = async (id, text) => {
  const response = await api.post(`/orders/${id}/notes`, { text });
  return response.data;
};

// إحصائيات الطلبات
export const getOrderStats = async () => {
  const response = await api.get('/orders/stats/overview');
  return response.data;
};

// تصدير الطلبات
export const exportOrders = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/orders/export?${queryParams}`, {
    responseType: 'blob'
  });
  return response.data;
};

// إرسال تذكير للعميل
export const sendOrderReminder = async (id) => {
  const response = await api.post(`/orders/${id}/reminder`);
  return response.data;
};

// تسجيل دفعة للطلب
export const recordPayment = async (id, paymentData) => {
  const response = await api.post(`/orders/${id}/payment`, paymentData);
  return response.data;
};
